import { countries } from './countries';
export const _usePayBanks = [
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'TCB',
        label: 'Techcombank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'SACOM',
        label: 'Sacombank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'VCB',
        label: 'Vietcombank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'ACB',
        label: 'Asia Commercial Bank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'DAB',
        label: 'DongA Bank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'VTB',
        label: 'Vietinbank',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'BIDV',
        label: 'Bank for Investment and Development of Vietnam',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'EXIM',
        label: 'Eximbank Vietnam',
    },
    {
        country: countries.vn.value,
        currency: 'VND',
        code: 'AGB',
        label: 'Vietnam Bank For Agriculture and Rural Development (Agribank)',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'KTB',
        label: 'Krung Thai Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'SCB',
        label: 'Siam Commercial Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'BBL',
        label: 'Bangkok Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'KBANK',
        label: 'Kasikorn Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'TMB',
        label: 'Thai Military Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'TH_KRUNGSRI',
        label: 'Bank of Ayudhya (Krungsri)',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'CIMBT',
        label: 'CIMB THAI BANK PUBLIC COMPANY LIMITED',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'GSB',
        label: 'Government Savings Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'TH_UOBT',
        label: 'United Overseas Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'GHB',
        label: 'Government Housing Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'Hong Kong Shanghai Bank',
        label: 'Hong Kong Shanghai Bank',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        code: 'STC',
        label: 'Standard Chartered Bank Thailand',
    },
    {
        country: countries.th.value,
        currency: 'VND',
        label: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        code: 'LHFG',
    },
    {
        country: countries.id.value,
        currency: 'IDR',
        label: 'Bank Central Asia',
        code: 'BCA',
    },
    {
        country: countries.id.value,
        currency: 'IDR',
        label: 'Bank Negara Indonesia',
        code: 'BNI',
    },
    {
        country: countries.id.value,
        currency: 'IDR',
        label: 'Bank Mandiri',
        code: 'MDR',
    },
    {
        country: countries.id.value,
        currency: 'IDR',
        label: 'Bank Rakyat Indonesia',
        code: 'BRI',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'AFF',
        label: 'AFFIN BANK BERHAD / AFFIN ISLAMIC BANK',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'ALL',
        label: 'ALLIANCE BANK MALAYSIA BHD',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'AMB',
        label: 'AMBANK BHD',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'BIMB',
        label: 'Bank Islam Malaysia',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'BANK RAKYAT MALAYSIA BERHAD',
        label: 'BANK RAKYAT MALAYSIA BERHAD',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'BSN',
        label: 'BANK SIMPANAN NASIONAL BHD',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'CIMB',
        label: 'CIMB Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'CITI',
        label: 'CITI Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'MY_HLB',
        label: 'Hong Leong Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'HSBC',
        label: 'HSBC BANK MALAYSIA BHD',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'MBB',
        label: 'Maybank Berhad',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        code: 'MY_OCBC',
        label: 'OCBC Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        value: 'MY_PUBLIC',
        label: 'Public Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        value: 'MY_RHB',
        label: 'RHB Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        value: 'SCTB',
        label: 'Standard Chartered Bank',
    },
    {
        country: countries.my.value,
        currency: 'MYR',
        value: 'UOB',
        label: 'UNITED OVERSEAS BANK (M) BMD',
    },
];
